"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapToDisclaimerProps({ data }) {
    let disclaimer = null;
    let raw = null;
    if (!('blockType' in data)) {
        disclaimer = data;
    }
    else if (data.disclaimerReference &&
        typeof data.disclaimerReference === 'object') {
        disclaimer = data.disclaimerReference;
        raw = disclaimer?.brandyRaw ?? null;
    }
    return {
        variant: 'legal',
        // TODO: eventually, we'll use sylexContent, we're only using the raw html for now
        // sylexContent:
        //   disclaimer?.content && mappers.mapRichText({richText: disclaimer?.content, mappers}),
        disclaimer: raw,
    };
}
exports.default = mapToDisclaimerProps;
